<template>
    <div v-if="$route.params.type == 'unpaid'">
        <h1 class="text-danger text-center brand-name mb-4 mt-4">RADAP</h1>
        <h4 class=" text-center success-msg">تراکنش ناموفق</h4>
        <div class="text-center m-top-4">
            <img src="https://radap.ir/imagesUploaded/other/close.jpg" width="170" height="150" />
        </div>
        <h5 class="text-center m-top-4">ممنون از همراهیت</h5>
        <div class="text-center m-top-4">
            <button class="btn btn-success rounded ml-2 mb-2" @click="goSite">بازگشت به راداَپ</button>
        </div>
     </div>
    <div class="container_fluid pt-4" v-else>
        <h1 class="text-danger text-center brand-name mb-4">RADAP</h1>
        <h4 class=" text-center success-msg">تراکنش با موفقیت انجام شد.</h4>
        <div class="text-center m-top-4">
            <img src="https://radap.ir/imagesUploaded/other/tick.jpeg" width="150" height="150" />
        </div>
        <h5 class="text-center m-top-4" style="height:20px">
            <Transition>
                <span v-if="show">
                    <i class="fa fa-certificate" aria-hidden="true"></i>
                    ۱۰ امتیاز بدست آوردی
                </span>
            </Transition>
        </h5>
        <h5 class="text-center m-top-4">ممنون از همراهیت</h5>
        <div class="text-center m-top-4">
            <button class="btn btn-success rounded ml-2 mb-2" @click="goSite">بازگشت به راداَپ</button>
            <button class="btn btn-info rounded mb-2" @click="goTrack" v-if="route.params.id">پیگیری سفارش</button>
        </div>
    </div>
</template>
<script setup>
import { useRoute } from "vue-router";
import {ref} from 'vue'
import { useBasket } from '@/store/basket'
let route = useRoute()
let show = ref(false)
let basketStore = useBasket()
setTimeout(() => { show.value = !show.value }, 1000);
if (route.params.id) {
    basketStore.getBasketSupplierID()    
    basketStore.deleteBasketInTrack()
}
function goSite() {
    location.href = 'https://radap.ir'
}
function goTrack() {
    location.href = 'https://radap.ir/Track/' + route.params.id
}
</script>
<style scoped>
.brand-name {
    font-family: Adera !important;
    letter-spacing: 1px;
}

.success-msg {
    font-weight: 700;
}

.m-top-4 {
    margin-top: 2.2rem !important;
}
.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>